import { LinkTypeEnum } from '../../../enums/link-type.enum';
import { MenuItem } from '../interfaces/menu-item.interface';
import { UserMainMenuItem } from '../interfaces/user-main-menu-item.interface';

export class UserMainMenuItemsAdapter {
  public static adapt(userItems: UserMainMenuItem[]): MenuItem[] {
    return userItems.map((item, index) => this._adaptToMenuItem(item, index));
  }

  private static _adaptToMenuItem(item: UserMainMenuItem, index: number): MenuItem {
    return {
      id: item.type,
      label: item.isHiddenName ? '' : item.name,
      url: item.url,
      iconUrl: item.iconUrl,
      countMark: item.isNew ? 'NEW' : '',
      hint: item.hint,
      urlType: this._getLinkType(item),
      items: [...(item.children?.map((child) => this._adaptToMenuItem(child, index)) || [])],
    };
  }

  private static _getLinkType(item: UserMainMenuItem): LinkTypeEnum {
    if (!item.isLink || !item.url || item.isOpenNewTab) {
      return item.isOpenNewTab ? LinkTypeEnum.URL_NEW_TAB : LinkTypeEnum.NO_URL;
    }

    return LinkTypeEnum.URL;
  }
}
